'use strict'

// The nearest page host is the full page or the modal dialog. Forms post to
// that page, so a form inside a dialog does not write to the page behind it.

function pageHostUniqueTitle (el) {

  const node = el && el.nodeType === 1 ? el : (el && el.parentElement)
  const host = node && node.closest ? node.closest('[page-unique-title]') : null

  if (host) return host.getAttribute('page-unique-title') || ''

  if (typeof document === 'undefined') return ''

  const fallback = document.getElementById('page-container')

  return fallback ? (fallback.getAttribute('page-unique-title') || '') : ''
}

export { pageHostUniqueTitle }
